import React from 'react';
import { withRouter } from 'react-router-dom';
import {createBundle} from 'actions/bundle';
import BundleEdit from 'components/BundleEdit';
import BaseModal from 'components/BaseModal';
class BundleNew extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            loading:false
        };
    }
    onSubmit = (params)=>{
        this.setState({loading:true});
        createBundle(params).then(res=>{
            BaseModal.success({
                title:'Success',
                onOk:()=>{
                    this.props.history.push('/pages/app/bundle');
                }
            });
        }).catch(()=>{
            this.setState({loading:false});
        });
    }

    render() {
        return(
            <BundleEdit loading={this.state.loading} onSubmit={this.onSubmit}/>
        );
    }
}

export default withRouter(BundleNew);




// WEBPACK FOOTER //
// ./src/pages/BundleNew/index.js